var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-breadcrumb",
    {
      staticClass: "app-breadcrumb",
      attrs: { "separator-class": "el-icon-d-arrow-right" }
    },
    [
      _vm._l(_vm.levelList, function(item, index) {
        return [
          index > 0 && item.meta.parentTitle
            ? _c("el-breadcrumb-item", { key: index }, [
                _vm._v(_vm._s(_vm.$t(item.meta.parentIndex.replace("/", ""))))
              ])
            : _vm._e(),
          _vm._v(" "),
          index > 0 && item.meta.title
            ? _c(
                "el-breadcrumb-item",
                { key: item.path },
                [
                  _c(
                    "router-link",
                    { attrs: { to: item.redirect || item.path } },
                    [_vm._v(_vm._s(_vm.$t(item.meta.index.replace("/", ""))))]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0415c493", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0415c493","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/breadcrumb.vue
// module id = null
// module chunks = 